var shell = require('shelljs')

module.exports = yargs => {
	shell.exec(`ifconfig | grep "inet " | grep -v 127.0.0.1 | cut -d\\  -f2`)
}



// WEBPACK FOOTER //
// ./src/commands/ip.js